import { WorkflowEntity, WorkflowFormEntity, WorkflowRequest, WorkflowsResponse } from 'src/types'
import { WorkflowType } from 'src/types/generated'

export const WorkflowTranslator = {
  toEntities: (response: WorkflowsResponse): WorkflowEntity[] => {
    return response.workflows.map(workflow => ({
      id: `${workflow.id}`,
      name: workflow.name,
      type: workflow.type as 'publish' | 'order',
      steps: workflow.workflowSteps
        .map(step => ({
          ...step,
          id: `${step.id}`,
          primaryCustomRoleIds: step.primaryRoleIds,
          secondaryCustomRoleIds: step.secondaryRoleIds ?? [],
          multiApproverCondition: step.multiApproverCondition
            ? (step.multiApproverCondition as 'AND' | 'OR')
            : undefined,
        }))
        .sort((a, b) => a.stepNumber - b.stepNumber),
    }))
  },

  toRequest: (formEntity: WorkflowFormEntity): WorkflowRequest => {
    return {
      name: formEntity.name,
      type: formEntity.type === 'publish' ? WorkflowType.Publish : WorkflowType.Order,
      workflowSteps: formEntity.steps.map((step, index) => ({
        label: step.label,
        stepNumber: index + 1,
        primaryRoleIds: step.primaryRoleIds,
        secondaryRoleIds: step.secondaryRoleIds,
        // TODO: IsApproverAddable から isApproverAddable にAPI側が変更になる予定
        IsApproverAddable: step.isApproverAddable,
        // TODO: API側がnullableになる予定
        multiApproverCondition: step.multiApproverCondition ?? 'AND',
      })),
    }
  },
}
